import { gsap } from 'gsap/all'
import buttonLoader from 'utility/button-loader'
import message from 'utility/message'
import { updateBubble } from 'ekom'

export const cart = {
  el: {
    addForms: document.querySelectorAll<HTMLFormElement>('.product-card__form, .product-page__form'),
    removeForms: document.querySelectorAll<HTMLFormElement>('.checkout-order-line__remove-form'),
    updateForms: document.querySelectorAll<HTMLFormElement>('.checkout-order-line__update-form'),
    deliveryForms: document.querySelectorAll<HTMLFormElement>('.checkout-footer__delivery-form'),
    paymentForms: document.querySelectorAll<HTMLFormElement>('.checkout-footer__payment-form'),
    freeDeliveryCircle: document.querySelector<HTMLElement>('.checkout-free-delivery__circle-svg'),
  },

  init() {
    this.el.addForms.forEach((form) => {
      form.addEventListener('submit', (event) => this.addToCart(form, event))
    })

    this.el.removeForms.forEach((form) => {
      form.addEventListener('submit', (event) => this.removeFromCart(form, event))
    })

    this.el.updateForms.forEach((form) => {
      form.querySelectorAll(`button[type=button]`).forEach((button) => {
        button.addEventListener('click', (event) => {
          this.updateOrderLine(form, event)
        })
      })
    })

    this.el.deliveryForms.forEach((form) => {
      form.addEventListener('submit', (event) => this.handleDelivery(form, event))
    })

    this.el.paymentForms.forEach((form) => {
      form.addEventListener('submit', (event) => this.handlePayment(form, event))
    })

    document
      .querySelectorAll('.checkout-page .switch input, .checkout-page select[form=delivery-form]')
      .forEach((input) => {
        input.addEventListener('change', (event) => this.handleShipping(event))
      })

    if (this.el.freeDeliveryCircle) this.updateFreeDeliveryCircle()
  },

  formDataToJson(formData: FormData): Object {
    const object: any = {}
    formData.forEach((value, key) => {
      object[key] = value
    })
    return object
  },

  addToCart(form, event) {
    event.preventDefault()
    const button = <HTMLButtonElement>form.querySelector(`button[type=submit]`)
    const messageElement = <HTMLDivElement>form.querySelector('.message')
    const formElement = new FormData(form)
    const formData = this.formDataToJson(formElement)

    this.fetchData({
      action: form.getAttribute('action'),
      method: form.getAttribute('method'),
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
      onStart: () => {
        if (button) buttonLoader.start(button)
      },
      onSuccess: (response) => {
        setTimeout(() => {
          button && buttonLoader.success(button)
        }, 500)
        if (messageElement) {
          //message.show(messageElement, '', 'success', 1234)
        }
        updateBubble(response.totalQuantity)
        this.updateFooter()
      },
      onStockError: () => {
        if (button) {
          buttonLoader.error(button)
        }
        if (messageElement) {
          message.show(messageElement, 'Vara ekki til á lager', 'error')
        }
      },
      onError: (ex) => {
        if (messageElement) {
          message.show(messageElement, `Server error: ${ex}`, 'error')
        }
        if (button) {
          buttonLoader.reset(button)
        }
      },
    })
  },

  removeFromCart(form, event) {
    event.preventDefault()

    const button = <HTMLButtonElement>form.querySelector(`button[type=submit]`)
    const formElement = new FormData(form)
    const formData = this.formDataToJson(formElement)
    this.fetchData({
      action: form.getAttribute('action'),
      method: form.getAttribute('method'),
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      onStart: () => {
        buttonLoader.start(button)
      },
      onSuccess: () => {
        window.location.reload()
      },
      onError: () => {
        buttonLoader.reset(button)
      },
    })
  },

  updateFooter() {
    const form = <HTMLFormElement>document.getElementById('footer-form')
    const formElement = new FormData(form)
    this.fetchDataString({
      action: form.getAttribute('action'),
      method: form.getAttribute('method'),
      body: formElement,
      onStart: () => {
        //buttonLoader.start(button)
      },
      onSuccess: (response) => {
        const footer = document.getElementsByClassName('checkout-footer')[0]
        const main = document.getElementById('main')

        if (footer) {
          footer.remove()
        }

        main.insertAdjacentHTML('beforeend', response)
      },
      onError: (ex) => {
        //buttonLoader.reset(button)
      },
    })
  },

  updateOrderLine(form, event) {
    const button = event.currentTarget
    const formElement = new FormData(form)
    const formData = this.formDataToJson(formElement)
    setTimeout(() => {
      this.fetchData({
        action: form.getAttribute('action'),
        method: form.getAttribute('method'),
        body: JSON.stringify(formData),
        headers: {
          'Content-Type': 'application/json',
        },
        onStart: () => {
          buttonLoader.start(button)
        },
        onSuccess: () => {
          window.location.reload()
        },
      })
    }, 1)
  },

  handleShipping(event) {
    event.preventDefault()
    const form = <HTMLFormElement>document.getElementById('delivery-form')
    const formElement = new FormData(form)
    //const formData = this.formDataToJson(formElement)
    this.fetchDataNonHeaders({
      action: form.getAttribute('action'),
      method: form.getAttribute('method'),
      body: formElement,
      onSuccess: () => {
        window.location.reload()
      },
    })
  },

  handleDelivery(form, event) {
    event.preventDefault()

    const button = <HTMLButtonElement>form.querySelector(`button[type=submit]`)
    const errorEl = <HTMLDivElement>document.querySelector('.checkout-page__error')
    const errorTextEl = errorEl.querySelector('span')
    const errorText = button.getAttribute('data-error-text')
    const nextStep = <unknown>button.getAttribute('data-link')
    const hideError = () => {
      errorEl.classList.add('checkout-page__error--hidden')
      errorTextEl.innerHTML = ''
      document.body.removeEventListener('click', hideError)
    }

    this.fetchDataNonHeaders({
      action: form.getAttribute('action'),
      method: form.getAttribute('method'),
      body: new FormData(form),
      onStart: () => {
        buttonLoader.start(button)
      },
      onError: () => {
        errorEl.classList.remove('checkout-page__error--hidden')
        errorTextEl.innerHTML = errorText
        document.body.addEventListener('click', hideError)
        buttonLoader.reset(button)
      },
      onSuccess: () => {
        setTimeout(() => {
          window.location = <Location>nextStep
        }, 500)
      },
    })
  },

  handlePayment(form, event) {
    event.preventDefault()
    const button = <HTMLButtonElement>form.querySelector(`button[type=submit]`)
    buttonLoader.start(button)
    form.submit()
  },

  updateFreeDeliveryCircle() {
    const percentage = this.el.freeDeliveryCircle.dataset.percentage
    const ring = this.el.freeDeliveryCircle.querySelector('[data-ring]')

    gsap.set(ring, { rotation: -90, transformOrigin: '50% 50%', drawSVG: `0 ${percentage}%` })
  },
  fetchDataNonHeaders({
    action,
    method,
    body,
    onStart = () => null,
    onStockError = (response: any) => response,
    onSuccess = (response: any) => response,
    onError = (ex: any) => ex,
  }) {
    onStart()

    fetch(action, {
      method,
      body,
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json()
        } else if (response.status === 409) {
          onStockError(response)
        }
      })
      .then((response) => {
        onSuccess(response)
      })
      .catch((ex) => {
        onError(ex)
      })
  },
  fetchData({
    action,
    method,
    body,
    onStart = () => null,
    onStockError = (response: any) => response,
    onSuccess = (response: any) => response,
    onError = (ex: any) => ex,
    headers = null,
  }) {
    onStart()

    fetch(action, {
      method,
      body,
      headers,
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json()
        } else if (response.status === 409) {
          onStockError(response)
        }
      })
      .then((response) => {
        onSuccess(response)
      })
      .catch((ex) => {
        onError(ex)
      })
  },
  fetchDataString({
    action,
    method,
    body,
    onStart = () => null,
    onStockError = (response: any) => response,
    onSuccess = (response: any) => response,
    onError = (ex: any) => ex,
  }) {
    onStart()

    fetch(action, {
      method,
      body,
    })
      .then((response) => {
        if (response.status === 200) {
          return response.text()
        } else if (response.status === 409) {
          onStockError(response)
        }
      })
      .then((response) => {
        onSuccess(response)
      })
      .catch((ex) => {
        onError(ex)
      })
  },
}
